import { initOnii } from "./mixins/onii.js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./axios";
import i18n from "./i18n";
import flagIcons from "flag-icon-css/css/flag-icons.css";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import moment from "moment";
Vue.prototype.moment = moment;

Vue.use(VueTelInput);

initOnii();

// Buefy + Icons
import Buefy from "buefy";
// import 'buefy/dist/buefy.css'
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEye,
  faEyeSlash,
  faPlusCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faArrowAltCircleLeft,
  faTimesCircle,
  faSave,
  faAngleDown,
  faSyncAlt,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faComments,
  faInfoCircle,
  faCog,
  faExternalLinkSquareAlt,
  faAngleLeft,
  faAngleRight,
  faSadCry,
  faBarcode,
  faQrcode,
  faFrown,
  faMinusCircle,
  faFileUpload,
  faCaretDown,
  faCaretUp,
  faCalendarDay,
  faTimes,
  faChevronUp,
  faMotorcycle,
  faUser,
  faDoorClosed,
  faHandPaper,
  faClipboard,
  faFileDownload,
  faList,
  faEdit,
  faStar,
  faCaretRight,
  faTrash,
  faTag,
  faPen,
  faClock,
  faCopy,
  faSatelliteDish,
  faEquals,
  faCrosshairs
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faEye,
  faEyeSlash,
  faPlusCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faArrowAltCircleLeft,
  faTimesCircle,
  faSave,
  faAngleDown,
  faSyncAlt,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faComments,
  faInfoCircle,
  faCog,
  faExternalLinkSquareAlt,
  faAngleLeft,
  faAngleRight,
  faSadCry,
  faBarcode,
  faQrcode,
  faFrown,
  faMinusCircle,
  faFileUpload,
  faCaretDown,
  faCaretUp,
  faCalendarDay,
  faTimes,
  faChevronUp,
  faMotorcycle,
  faUser,
  faDoorClosed,
  faHandPaper,
  faClipboard,
  faFileDownload,
  faList,
  faEdit,
  faStar,
  faCaretRight,
  faTrash,
  faTag,
  faPen,
  faClock,
  faCopy,
  faSatelliteDish,
  faEquals,
  faCrosshairs
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: "font-awesome-icon",
  defaultIconPack: "fas"
});

// Other Vue Config
Vue.prototype.$http = http;

Vue.config.productionTip = false;

Vue.use(flagIcons);

// whitelabel config
Vue.prototype.$primaryColor = process.env.VUE_APP_PRIMARY_COLOR;
Vue.prototype.$primaryColorContrast =
  process.env.VUE_APP_PRIMARY_COLOR_CONTRAST;
const chain = process.env.VUE_APP_CHAIN;
Vue.prototype.$chain = chain;

if (typeof document !== "undefined") {
  document.body.classList.toggle("chain-mq", chain === "mq");
  document.body.classList.toggle("chain-brmania", chain === "brmania");
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
